import styled from "styled-components";

export const ProductWarrantyRegisterContainerStyled = styled.div`
  border-radius: 1rem;
  padding: 1.25rem 1rem;
  width: 100%;
  max-width: 30vw;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
`;
